// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ---------- Tooltip ---------- */
.tooltip-btn {
    width: 30px;
    height: 30px;
    border-radius: 8px;
    border: none;
    background-color: var(--mainColor);
    position: relative;

    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 7px;
    border-radius: 8px;
    cursor: pointer;

}


.delete-btn {
    background-color: rgb(230, 230, 230);
}


.margin-btn {
    margin-right: 10px;

}



.tooltip-btn img {
    width: 22px;
    height: 22px;
    display: block;
}

.tooltip-btn:hover svg {
    animation: jello-vertical 0.7s both;
}

@keyframes jello-vertical {
    0% {
        transform: scale3d(1, 1, 1);
    }

    30% {
        transform: scale3d(0.75, 1.25, 1);
    }

    40% {
        transform: scale3d(1.25, 0.75, 1);
    }

    50% {
        transform: scale3d(0.85, 1.15, 1);
    }

    65% {
        transform: scale3d(1.05, 0.95, 1);
    }

    75% {
        transform: scale3d(0.95, 1.05, 1);
    }

    100% {
        transform: scale3d(1, 1, 1);
    }
}

.tooltip {
    position: absolute;
    top: -20px;
    opacity: 0;
    background-color: #000;
    color: white;
    padding: 5px 10px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition-duration: 0.2s;
    pointer-events: none;
    letter-spacing: 0.5px;
}

.tooltip::before {
    position: absolute;
    content: "";
    width: 10px;
    height: 10px;
    background-color: #000;
    transform: rotate(45deg);
    bottom: -15%;
    transition-duration: 0.3s;
}

.tooltip-btn:hover .tooltip {
    top: -50px;
    opacity: 1;
    transition-duration: 0.3s;
}







.button-group {
    display: flex;
    gap: 1px; /* فاصله بین دکمه‌ها */
    flex-wrap: nowrap; /* جلوگیری از شکست خط */
}




@media (max-width: 820px) {
    .button-group {
        gap:1px;
    }

    .tooltip-btn {
        width: 25px;
        height: 25px;
        padding: 5px;
    }

    .tooltip-btn img {
        width: 13px;
        height: 13px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Button/TooltipButton.css"],"names":[],"mappings":"AAAA,kCAAkC;AAClC;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,kCAAkC;IAClC,kBAAkB;;IAElB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,eAAe;;AAEnB;;;AAGA;IACI,oCAAoC;AACxC;;;AAGA;IACI,kBAAkB;;AAEtB;;;;AAIA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI;QACI,2BAA2B;IAC/B;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,wBAAwB;IACxB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,UAAU;IACV,yBAAyB;AAC7B;;;;;;;;AAQA;IACI,aAAa;IACb,QAAQ,EAAE,sBAAsB;IAChC,iBAAiB,EAAE,uBAAuB;AAC9C;;;;;AAKA;IACI;QACI,OAAO;IACX;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;AACJ","sourcesContent":["/* ---------- Tooltip ---------- */\n.tooltip-btn {\n    width: 30px;\n    height: 30px;\n    border-radius: 8px;\n    border: none;\n    background-color: var(--mainColor);\n    position: relative;\n\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 7px;\n    border-radius: 8px;\n    cursor: pointer;\n\n}\n\n\n.delete-btn {\n    background-color: rgb(230, 230, 230);\n}\n\n\n.margin-btn {\n    margin-right: 10px;\n\n}\n\n\n\n.tooltip-btn img {\n    width: 22px;\n    height: 22px;\n    display: block;\n}\n\n.tooltip-btn:hover svg {\n    animation: jello-vertical 0.7s both;\n}\n\n@keyframes jello-vertical {\n    0% {\n        transform: scale3d(1, 1, 1);\n    }\n\n    30% {\n        transform: scale3d(0.75, 1.25, 1);\n    }\n\n    40% {\n        transform: scale3d(1.25, 0.75, 1);\n    }\n\n    50% {\n        transform: scale3d(0.85, 1.15, 1);\n    }\n\n    65% {\n        transform: scale3d(1.05, 0.95, 1);\n    }\n\n    75% {\n        transform: scale3d(0.95, 1.05, 1);\n    }\n\n    100% {\n        transform: scale3d(1, 1, 1);\n    }\n}\n\n.tooltip {\n    position: absolute;\n    top: -20px;\n    opacity: 0;\n    background-color: #000;\n    color: white;\n    padding: 5px 10px;\n    border-radius: 5px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition-duration: 0.2s;\n    pointer-events: none;\n    letter-spacing: 0.5px;\n}\n\n.tooltip::before {\n    position: absolute;\n    content: \"\";\n    width: 10px;\n    height: 10px;\n    background-color: #000;\n    transform: rotate(45deg);\n    bottom: -15%;\n    transition-duration: 0.3s;\n}\n\n.tooltip-btn:hover .tooltip {\n    top: -50px;\n    opacity: 1;\n    transition-duration: 0.3s;\n}\n\n\n\n\n\n\n\n.button-group {\n    display: flex;\n    gap: 1px; /* فاصله بین دکمه‌ها */\n    flex-wrap: nowrap; /* جلوگیری از شکست خط */\n}\n\n\n\n\n@media (max-width: 820px) {\n    .button-group {\n        gap:1px;\n    }\n\n    .tooltip-btn {\n        width: 25px;\n        height: 25px;\n        padding: 5px;\n    }\n\n    .tooltip-btn img {\n        width: 13px;\n        height: 13px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
